import * as Yup from "yup";
import { isNameValid } from "../../../constants/formValidationSchemas";
import { CreateProductVersionModalKeys } from "../../../constants/product";
import { RED_HAT_NAMING_GUIDELINE_ERROR } from "../../../constants/validation";

const REQUIRED_MESSAGE = "This field is required";
const MAX_255_MESSAGE = "This field should be less than or equal to 255 characters";

export const ProductVersionModalValidator: Yup.ObjectSchema = Yup.object().shape({
	[CreateProductVersionModalKeys.productVersion]: Yup.string()
		.required(REQUIRED_MESSAGE)
		.max(255, MAX_255_MESSAGE)
		.test("is-name-valid", RED_HAT_NAMING_GUIDELINE_ERROR, isNameValid),
	[CreateProductVersionModalKeys.selectedVersions]: Yup.array()
		.of(
			Yup.object().shape({
				versions: Yup.array(),
			}),
			// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Yup test callback receives untyped data
		)
		.test("at-least-one-selection", "At least one selection is required", (data: any) => {
			const items = data as Array<{ short_name?: string; versions?: unknown[] }> | undefined;
			return !!items?.some(
				(elm) =>
					(elm?.short_name === "RHOCP" && (elm?.versions?.length ?? 0) > 0) ||
					(elm?.short_name === "RHEL" && (elm?.versions?.length ?? 0) > 0),
			);
		})
		.min(1, "At least one selection is required"),
});
